<app-grid>
  <div class="col-span-12 dark:border-[#404040] dark:text-white text-sm rounded-l h-full flex flex-col items-center">
    @if (!loadingDevices) {
      @if(devices && devices.length == 0){
        <div class="max-w-sm m-auto mt-16 text-center fle flex-col items-center">
          <h3 class="grow text-primary text-xl font-bold">Register a new node</h3>
          <p>Here you can register your node. After registration you can see the node's messages that are received by our satellites.</p>
          <button
            class="w-52 h-52 border border-dashed border-base-300 rounded m-auto mt-16 flex items-center"
            (click)="openDialogDevice('register')">
            <div class="m-auto">
              <span class="w-full text-primary text-lg">Register new node</span>
              <svg class="m-auto mt-4" width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="54" height="54" rx="27" fill="#7B35C6"/>
                <path d="M27.0005 21.5835C27.4146 21.5835 27.7503 21.9194 27.7505 22.3335V26.2505H31.6665C32.0807 26.2505 32.4165 26.5863 32.4165 27.0005C32.4165 27.4147 32.0807 27.7505 31.6665 27.7505H27.7505V31.6665C27.7505 32.0807 27.4147 32.4165 27.0005 32.4165C26.5863 32.4165 26.2505 32.0807 26.2505 31.6665V27.7505H22.3335C21.9194 27.7503 21.5835 27.4146 21.5835 27.0005C21.5835 26.5864 21.9194 26.2507 22.3335 26.2505H26.2505V22.3335C26.2507 21.9194 26.5864 21.5835 27.0005 21.5835Z" fill="white"/>
              </svg>
              </div>
          </button>
        </div>
      }
      @if(devices && devices.length > 0){

        <div class="flex justify-between max-w-full w-full items-center pb-6 pt-6">
          <h3 class="grow text-primary text-xl font-bold dark:text-white">Nodes</h3>
          <div>
            <button
              class="btn btn-primary btn-sm font-normal w-full"
              (click)="openDialogDevice('register')">
              <span>Register new node</span>
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.41699 0C5.8311 0 6.16682 0.335936 6.16699 0.75V4.66699H10.083C10.4972 4.66699 10.833 5.00278 10.833 5.41699C10.833 5.83121 10.4972 6.16699 10.083 6.16699H6.16699V10.083C6.16699 10.4972 5.83121 10.833 5.41699 10.833C5.00278 10.833 4.66699 10.4972 4.66699 10.083V6.16699H0.75C0.335936 6.16682 0 5.8311 0 5.41699C0 5.00289 0.335936 4.66717 0.75 4.66699H4.66699V0.75C4.66717 0.335936 5.00289 0 5.41699 0Z" fill="white"/>
              </svg>

            </button>
          </div>
        </div>
        <div class="overflow-x-auto w-full max-w-full">
          <table class="w-full">
            <thead class="dark:text-white">
            <tr>
              <th class="text-[10px] p-2 font-normal text-left">Address</th>
              <th class="text-[10px] p-2 font-normal text-left">NetworkSKey</th>
              <th sortable field="description" [sortBy]="sortField" [sortOrder]="sortDirection" (sort)="toggleSort($event)" class="text-[10px] p-2 font-normal text-left">Description</th>
              <th class="text-[10px] p-2 font-normal text-left">F</th>
              <th sortable field="last_seen" [sortBy]="sortField" [sortOrder]="sortDirection" (sort)="toggleSort($event)" class="text-[10px] p-2 font-normal text-left">Last seen</th>
              <th class="w-[80px]"></th>
            </tr>
            </thead>
            <tbody>
              @for (device of devices; track device){
                <tr (click)="getDeviceMessages(device)" [ngClass]="isSelectedDevice(device)" class="dark:bg-black border-gray-300  dark:border-[#404040] cursor-pointer">
                  <td class="align-top font-mono p-2 text-xs border border-x-0 border-gray-300 dark:border-[#404040]">{{device.devaddr}}</td>
                  <td class="align-top font-mono p-2 text-xs border border-x-0 border-gray-300 dark:border-[#404040] text-wrap break-all">{{ device.network_key }}</td>
                  <td class="align-top text-xs p-2  border border-x-0 border-gray-300 dark:border-[#404040] text-wrap break-all">{{ device.description }}</td>
                  <td class="align-top text-xs p-2  border border-x-0 px-4 border-gray-300 dark:border-[#404040]">{{ device.last_fcnt }}</td>
                  <td class="align-top text-xs p-2  border border-x-0 border-gray-300 dark:border-[#404040]">
                    <div class="text-nowrap">{{dateTimeUtils.extractDate(device?.last_seen) }}</div>
                  </td>
                  <td class="align-top border border-l-0 rounded-r-sm border-gray-300 dark:border-[#404040]">
                    <div class="actions flex items-center pt-1">
                      <button
                        class="btn btn-ghost btn-xs mx-1"
                        (click)="openDialogDevice('update',device)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-4">
                          <path d="M21.174 6.81189C21.7027 6.28332 21.9998 5.56636 21.9999 4.81875C22 4.07113 21.7031 3.3541 21.1745 2.82539C20.6459 2.29668 19.929 1.99961 19.1813 1.99951C18.4337 1.99942 17.7167 2.29632 17.188 2.82489L3.842 16.1739C3.60981 16.4054 3.43811 16.6904 3.342 17.0039L2.021 21.3559C1.99515 21.4424 1.9932 21.5342 2.01535 21.6217C2.03749 21.7092 2.08292 21.7891 2.14679 21.8529C2.21067 21.9167 2.29062 21.962 2.37815 21.984C2.46569 22.006 2.55755 22.0039 2.644 21.9779L6.997 20.6579C7.31017 20.5626 7.59517 20.392 7.827 20.1609L21.174 6.81189Z" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                      <button
                        class="btn btn-ghost btn-xs mr-1"
                        (click)="confirmDelete(device)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="size-4">
                          <path d="M3 6H21" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M19 6V20C19 21 18 22 17 22H7C6 22 5 21 5 20V6" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3 9 2 10 2H14C15 2 16 3 16 4V6" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#404040" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>

                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }@else{
      <div class="flex w-full flex-col gap-2 mt-8">
        <div class="flex gap-2 flex-row">
          <div class="skeleton h-10 w-1/24"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-4/12"></div>
          <div class="skeleton h-10 w-4/12"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-3/24"></div>
        </div>
        <div class="flex gap-2 flex-row">
          <div class="skeleton h-10 w-1/24"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-4/12"></div>
          <div class="skeleton h-10 w-4/12"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-3/24"></div>
        </div>
        <div class="flex gap-2 flex-row">
          <div class="skeleton h-10 w-1/24"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-4/12"></div>
          <div class="skeleton h-10 w-4/12"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-1/12"></div>
          <div class="skeleton h-10 w-3/24"></div>
        </div>
      </div>
    }

    <div class="w-full text-left mt-6">
    @if(loadingMessages){
      <h3 class="pb-4 pt-6 text-primary text-xl font-bold">Messages</h3>
      <div class="flex w-full flex-col gap-2 mt-4">
        <div class="flex gap-2 flex-row">
          <div class="skeleton h-10 w-1/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-15/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
        </div>
        <div class="flex gap-2 flex-row">
          <div class="skeleton h-10 w-1/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-15/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
        </div>
        <div class="flex gap-2 flex-row">
          <div class="skeleton h-10 w-1/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
          <div class="skeleton h-10 w-15/24"></div>
          <div class="skeleton h-10 w-2/24"></div>
        </div>
      </div>
    } @else {
      @if (messages && messages.length > 0) {
        <h3 class="pb-4 pt-6 text-primary text-xl font-bold">Messages</h3>
        <p>The payload shown in the received messages is the encrypted LoraWAN packet. Lacuna Space cannot decrypt it, since it does not have the application key. Messages are retained for 1 month after delivery.</p>
        <div class="overflow-x-auto w-full max-w-full">
          <table class="w-full">
            <thead class="dark:text-white">
            <tr>
              <th class="text-[10px] p-2 font-normal text-left">Id</th>
              <th class="text-[10px] font-normal text-left">Reception Date</th>
              <th class="text-[10px] font-normal text-left">Hub Date</th>
              <th class="text-[10px] p-2 font-normal text-left">Deliver Date</th>
              <th class="text-[10px] font-normal text-left">Payload (encrypted LoraWAN packet)</th>
              <th class="text-[10px] font-normal text-left">Status</th>
            </tr>
            </thead>
            <tbody>
              @for (message of messages; track message){
                <tr class="bg-white dark:bg-black dark:text-white">
                  <td class="dark:border-[#404040] align-top text-xs p-2 border border-gray-300 border-r-0 rounded-l-sm">{{message.id}}</td>
                  <td class="dark:border-[#404040] align-top text-xs p-2 border border-gray-300 border-x-0">
                    <div class="text-nowrap">{{dateTimeUtils.extractDate(message.reception_date) }}</div>
                    <div>{{dateTimeUtils.extractTime(message.reception_date) }}</div>
                  </td>
                  <td class="dark:border-[#404040] align-top text-xs p-2 border border-gray-300 border-x-0">
                    <div class="text-nowrap">{{dateTimeUtils.extractDate(message.hub_date) }}</div>
                    <div>{{dateTimeUtils.extractTime(message.hub_date) }}</div>
                  </td>
                  <td class="dark:border-[#404040] align-top text-xs p-2 border border-gray-300 border-x-0">
                    <div class="text-nowrap">{{dateTimeUtils.extractDate(message.done_date) }}</div>
                    <div>{{dateTimeUtils.extractTime(message.done_date) }}</div>
                  </td>
                  <td class="dark:border-[#404040] font-mono align-top text-xs p-2 border border-gray-300 border-x-0 text-wrap break-all">{{ message.payload }}</td>
                  <td class="dark:border-[#404040] p-2 align-top text-xs border border-gray-300 border-l-0 rounded-r-sm">{{ message.status }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (messages && messages.length == 0) {
        <h3 class="pb-4 pt-6 text-primary text-xl font-bold">Messages</h3>
        <div>No messages found. We retain messages for 1 month.</div>
      }
    }
    </div>
  </div>
</app-grid>
